// extracted by mini-css-extract-plugin
module.exports = {"cards":"catalog-list_cards__0XjOD"};